module.exports = __webpack_public_path__ + "img/12.e0a2f0d2.jpg";